import React from "react";

const SuperpowerBulb = (props) => {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1005 19.873H4.79549C4.33786 19.873 3.98193 20.229 3.98193 20.6866C3.98193 21.1442 4.33786 21.5002 4.79549 21.5002H11.1514C11.609 21.5002 11.9649 21.1442 11.9649 20.6866C11.9649 20.229 11.5582 19.873 11.1005 19.873Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M7.94917 0.499878C3.72885 0.499878 0.27124 3.95749 0.27124 8.17781C0.27124 11.3303 1.89835 13.11 3.42377 14.3303V17.1269C3.42377 17.5845 3.7797 17.9405 4.23732 17.9405H11.7627C12.2203 17.9405 12.5763 17.5845 12.5763 17.1269V14.3303C14 13.1608 15.7288 11.3303 15.7288 8.17781C15.6779 3.95749 12.2203 0.499878 7.94917 0.499878ZM11.2542 13.2625C11.1017 13.4151 10.9492 13.6693 10.9492 13.8727V16.2625H5.00003V13.8727C5.00003 13.6185 4.89834 13.4151 4.6441 13.2625C3.22038 12.1947 1.8475 10.8219 1.8475 8.17781C1.89835 4.77104 4.59325 2.07614 8.00002 2.07614C11.4068 2.07614 14.1017 4.82189 14.1017 8.17781C14.0508 10.8219 12.5763 12.2964 11.2542 13.2625Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default SuperpowerBulb;
